import { compoundsForGoal } from '../lib/compounds';
import { GOAL_BY_ID } from '../lib/goals';
import { compoundCard } from './home';

export function renderGoal(params: Record<string, string>) {
  const app = document.getElementById('app')!;
  const g = GOAL_BY_ID[params.id];
  if (!g) {
    app.innerHTML = `<h2>Unknown goal</h2><p><a href="/">Back home</a></p>`;
    return;
  }
  const compounds = compoundsForGoal(params.id);
  app.innerHTML = `
    <h1>${g.icon} ${esc(g.label)}</h1>
    <p style="color:var(--dim);">Compounds frequently discussed for this goal. Evidence and dosing vary — read each before stacking.</p>
    <div class="compound-grid">${compounds.map(compoundCard).join('')}</div>
    ${compounds.length === 0 ? '<p style="color:var(--dim);">No compounds tagged for this goal yet — check back soon.</p>' : ''}
    <p style="margin-top:24px;"><a href="/">← All compounds</a></p>
  `;
}

function esc(s: string) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
